import Vue from 'vue'
import App from './App.vue'
import router from './router'
import config from './config'

document.documentElement.style.fontSize = '16px'

Vue.config.productionTip = false

function goError (msg) {
  return {
    name: config.errorPageRouteName,
    query: { msg: msg || '请重新扫码进入！' }
  }
}

/** 需校验 orderId + token 的收银台页（含银联聚合码建行/邮政/农行等） */
const CASHIER_TOKEN_ROUTES = new Set([
  'UnifiedPay',
  'LnetcPay',
  'JhuidPay',
  'YzPay',
  'NhPay',
  'ZjfsPay',
  'GhPay',
  'YzyhfPay',
  'HbnxPay',
  'WpgjPay',
  'WxJsPay',
  'AlipayCardPay',
  'UidManualPay',
  'ZhifutdPay',
  'YwzfPay'
])

router.beforeEach((to, from, next) => {
  if (config.passGuardRouteList.includes(to.name)) {
    next()
    return
  }

  // 统一收银台 / LNETC / 聚合码：共用 orderId + t 校验
  if (CASHIER_TOKEN_ROUTES.has(to.name)) {
    const orderId = to.params.orderId || to.query.orderId
    const token = to.query.t || to.query.token
    if (!orderId || !token) {
      next(goError('收银台参数缺失，请重新下单！'))
      return
    }
    next()
    return
  }

  next(goError('页面不存在'))
})

Vue.prototype.$config = config

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
